<div
  class="upload-area"
  dvFileDragDrop
  [multiple]="true"
  [ngClass]="{ active: hasBaseDropZoneOver }"
  (fileOver)="fileOverBase($event)"
  (fileDrop)="dropped($event)">
  <div class="upload-area__upload-button">
    <input
      [id]="fileInputId"
      type="file"
      (change)="onFileSelected($event)"
      multiple />
    <div class="upload-button__selection">
      <dv-button (click)="browse()">
        {{ 'General.Browse' | translate | uppercase }}
      </dv-button>
    </div>
  </div>
  {{ 'FileUpload.FileDragZoneNote' | translate }}
</div>

<div class="files-list">
  @for (attachment of attachedFiles; track $index; let ind = $index) {
    <div class="files-list__file-box">
      <div class="files-list__text">
        <div class="files-list__name">
          <div class="files-list__name--title">
            {{ 'FileUpload.FileName' | translate }}:
          </div>
          <div class="files-list__name--value">
            {{ attachment.file.name }}
          </div>
        </div>

        <div class="files-list__status">
          <div class="files-list__status--title">
            {{ 'FileUpload.Status' | translate }}:
          </div>

          <div class="files-list__name--value">
            @switch (attachment.status) {
              @case (uploadStatus.Empty) {
                <div class="files-list__name--value--content">
                  <div>
                    <span class="dv-icons error">error_filled</span>
                  </div>
                  <div>{{ 'FileUpload.Empty' | translate }}</div>
                </div>
              }

              @case (uploadStatus.TooBig) {
                <div class="files-list__name--value--content">
                  <span class="dv-icons error">error_filled</span>
                  {{ 'FileUpload.TooBig' | translate }}
                </div>
              }

              @case (uploadStatus.Success) {
                <div class="files-list__name--value--content">
                  <span class="dv-icons success">check</span>
                  {{ 'FileUpload.ReadyToAttach' | translate }}
                </div>
              }
            }
          </div>
        </div>
      </div>

      <div class="files-list__file-box--delete" (click)="deleteFile(ind)">
        <span class="dv-icons">close</span>
      </div>
    </div>
  }
</div>

<div class="upload-footer">
  <div class="upload-footer__documents">
    {{ 'FileUpload.DocumentsToUpload' | translate }}:
    <b>{{ readyToAttachFilesNo }}</b>
  </div>
  <div class="upload-footer__buttons">
    <dv-button (click)="onCancelClick()">{{
      'General.Cancel' | translate
    }}</dv-button>
    <dv-button
      color="secondary"
      (click)="onConfirmClick()"
      [disabled]="isFileUploadInProgress || !readyToAttachFilesNo"
      >{{ 'General.Add' | translate }} ({{ readyToAttachFilesNo }})</dv-button
    >
  </div>
</div>
